import React from 'react'
import PropTypes from 'prop-types'
import DynamicImage from '@app/components/dynamic-image'

/**
 * PDC Secure Payments Icon component
 * @param {object} icon - icon object
 * @param {string} title - title
 * @param {string} alt - alt
 * @returns {JSX.Element} - PDC Cart Secure Payments component
 */
export const PDCSecurePaymentsIcon = ({icon, title, alt, custom}) => {
    return (
        <DynamicImage
            src={custom?.icon?.disBaseLink || icon?.url}
            imageProps={{
                alt: alt,
                title: title,
                width: '40px',
                height: '40px'
            }}
        />
    )
}

PDCSecurePaymentsIcon.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.object,
    alt: PropTypes.string,
    custom: PropTypes.object
}
